import { useState } from 'react'
import { Box, Button, Container, Paper, TextField, Typography } from '@mui/material'
import location from '../../assets/images/location.png'

export default function ContactSection() {
  const [form, setForm] = useState({
    fullName: '',
    phoneNumber: '',
    businessName: '',
    location: '',
    message: '',
  })

  const [loading, setLoading] = useState(false)
  const [status, setStatus] = useState('')

  const handleChange = (e) => {
    setForm({
      ...form,
      [e.target.name]: e.target.value,
    })
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    setLoading(true)
    setStatus('')

    try {
      const res = await fetch('http://localhost:3000/api/telegram/send', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(form),
      })

      const data = await res.json()

      if (!res.ok) {
        throw new Error(data.error || 'Failed to send request.')
      }

      setStatus('Request sent successfully.')

      setForm({
        fullName: '',
        phoneNumber: '',
        businessName: '',
        location: '',
        message: '',
      })
    } catch (err) {
      setStatus(err.message || 'Failed to send request.')
    } finally {
      setLoading(false)
    }
  }

  return (
    <Box id="contact" sx={{ py: 10 }}>
      <Container maxWidth="lg">
        <Paper
          sx={{
            position: 'relative',
            overflow: 'hidden',
            p: { xs: 3, md: 5 },
            borderRadius: 5,
            backgroundImage: `url(${location})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            border: '1px solid rgba(255,255,255,0.08)',
            color: '#fff',
          }}
        >
          <Box
            sx={{
              position: 'absolute',
              inset: 0,
              background: 'rgba(0,0,0,0.55)',
              zIndex: 1,
            }}
          />

          <Box sx={{ position: 'relative', zIndex: 2 }}>
            <Box
              sx={{
                display: 'grid',
                gridTemplateColumns: { xs: '1fr', md: '0.9fr 1.1fr' },
                gap: 4,
              }}
            >
              <Box>
                <Typography variant="overline" sx={{ color: 'rgba(255,255,255,0.7)' }}>
                  Contact
                </Typography>

                <Typography variant="h3" sx={{ fontWeight: 700, mt: 1, mb: 2 }}>
                  Let’s evaluate your location
                </Typography>

                <Typography sx={{ color: 'rgba(255,255,255,0.82)', lineHeight: 1.8 }}>
                  Tell us about your business and location. We will review the fit and
                  recommend the best vending option for your space.
                </Typography>
              </Box>

              <Box
                component="form"
                onSubmit={handleSubmit}
                sx={{
                  display: 'grid',
                  gap: 2,
                }}
              >
                <TextField
                  fullWidth
                  required
                  name="fullName"
                  value={form.fullName}
                  onChange={handleChange}
                  label="Full Name"
                  variant="outlined"
                  InputLabelProps={{ style: { color: 'rgba(255,255,255,0.7)' } }}
                  sx={fieldStyles}
                />

                <TextField
                  fullWidth
                  required
                  name="phoneNumber"
                  value={form.phoneNumber}
                  onChange={handleChange}
                  label="Phone Number"
                  variant="outlined"
                  InputLabelProps={{ style: { color: 'rgba(255,255,255,0.7)' } }}
                  sx={fieldStyles}
                />

                <TextField
                  fullWidth
                  required
                  name="businessName"
                  value={form.businessName}
                  onChange={handleChange}
                  label="Business Name"
                  variant="outlined"
                  InputLabelProps={{ style: { color: 'rgba(255,255,255,0.7)' } }}
                  sx={fieldStyles}
                />

                <TextField
                  fullWidth
                  required
                  name="location"
                  value={form.location}
                  onChange={handleChange}
                  label="City / Location"
                  variant="outlined"
                  InputLabelProps={{ style: { color: 'rgba(255,255,255,0.7)' } }}
                  sx={fieldStyles}
                />

                <TextField
                  fullWidth
                  required
                  multiline
                  minRows={4}
                  name="message"
                  value={form.message}
                  onChange={handleChange}
                  label="Tell us about your traffic and customer flow"
                  variant="outlined"
                  InputLabelProps={{ style: { color: 'rgba(255,255,255,0.7)' } }}
                  sx={fieldStyles}
                />

                <Button
                  type="submit"
                  disabled={loading}
                  variant="contained"
                  size="large"
                  sx={{
                    mt: 1,
                    py: 1.6,
                    borderRadius: 3,
                    textTransform: 'none',
                    fontWeight: 700,
                    bgcolor: '#fff',
                    color: '#111',
                    '&:hover': {
                      bgcolor: '#f3f3f3',
                    },
                    '&:disabled': {
                      bgcolor: 'rgba(255,255,255,0.7)',
                      color: '#111',
                    },
                  }}
                >
                  {loading ? 'Sending...' : 'Submit Request'}
                </Button>

                {status && (
                  <Typography sx={{ color: '#fff', textAlign: 'center', mt: 1 }}>
                    {status}
                  </Typography>
                )}
              </Box>
            </Box>
          </Box>
        </Paper>
      </Container>
    </Box>
  )
}

const fieldStyles = {
  '& label': {
    color: 'rgba(255,255,255,0.7)',
  },
  '& label.Mui-focused': {
    color: '#fff',
  },
  '& .MuiOutlinedInput-root': {
    color: '#fff',
    borderRadius: 3,
    background: 'linear-gradient(90deg, rgba(0,0,0,0.72) 0%, rgba(0,0,0,0.45) 100%)',
    backdropFilter: 'blur(6px)',
    '& fieldset': {
      borderColor: 'rgba(255,255,255,0.16)',
    },
    '&:hover fieldset': {
      borderColor: 'rgba(255,255,255,0.28)',
    },
    '&.Mui-focused fieldset': {
      borderColor: '#ffffff',
    },
  },
}